export default {
  ADWORDS: "Adwords",
  SEPHORAADWORDS: "sephoraAdwords",
  LISTING: "ListingPage",
  ECOMM_LISTING: "category",
  PRODUCT: "product",
};



// WEBPACK FOOTER //
// ./src/analytics/eventFactory/GTMEvents.js